<template>
  <v-app>
    <v-container fluid>

      <v-row v-if="loading && !selectedLcData">
        <v-col cols="12" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-2">Loading...</p>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12">

          <v-expansion-panels v-model="panel">
            <v-expansion-panel>

              <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header mb-4"
              >
                LC Amendment Form
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-form @submit.prevent="submit" ref="amendmentForm" >

                  <v-row>
                    <v-col md="4" cols="12" >

                      <v-expansion-panels v-model="panel1" multiple >
                        <v-expansion-panel>

                          <v-expansion-panel-title class="panel-header mb-4">
                            LC Selection & Amendment Info
                          </v-expansion-panel-title>

                          <v-expansion-panel-text>
                            <v-autocomplete
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="lc_id.value.value"
                              :items="getLcImportLcMasterList"
                              :item-title="item => `${item.lc_no} - ${item.code || ''}`"
                              item-value="id"
                              :error-messages="lc_id.errorMessage.value"
                              @update:modelValue="loadLcData"
                              clearable
                              :disabled="isEditMode"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                              <template #label>
                                Select LC
                                <span class="text-red-accent-4">*</span>
                              </template>
                            </v-autocomplete>

                            <v-text-field
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="amendment_no.value.value"
                              :error-messages="amendment_no.errorMessage.value"
                              label="Amendment No"
                              required
                            ></v-text-field>

                            <v-select
                              variant="outlined"
                              density="compact"
                              bg-color="grey-lighten-4"
                              v-model="amendment_types.value.value"
                              :items="amendmentTypeOptions"
                              label="Amendment Types"
                              multiple
                              chips
                              clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                              <template #label>
                                Amendment Types
                              </template>
                            </v-select>

                            <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="amendment_charge.value.value"
                                :error-messages="amendment_charge.errorMessage.value"
                                label="Amendment Charge"
                                type="number"
                                prefix="৳"
                            ></v-text-field>

                            <v-date-input
                                input-format="dd/mm/yyyy"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="amendment_date.value.value"
                                :error-messages="amendment_date.errorMessage.value"
                                label="Amendment Date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                required
                            ></v-date-input>

                            <v-textarea
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="remarks.value.value"
                                label="Remarks"
                                rows="3"
                            ></v-textarea>

                            <v-file-input
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="documents.value.value"
                                label="Upload Documents"
                                multiple
                                prepend-icon="mdi-paperclip"
                                show-size
                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                            ></v-file-input>

                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>

                    </v-col>

                    <v-col md="8" cols="12" >
                      <v-expansion-panels v-model="panel2" multiple >
                        <v-expansion-panel>

                          <v-expansion-panel-title class="panel-header mb-4">
                            LC Master Amendment
                          </v-expansion-panel-title>

                          <v-expansion-panel-text>

                            <v-row v-if="selectedLcData">

                              <v-col cols="12" md="6" >

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.supplier_id"
                                    :items="getSupplierList"
                                    :item-title="item => `${item.code} - ${item.name || item.supplier_name}`"
                                    item-value="id"
                                    label="Supplier"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.bank_id"
                                    :items="getLcBankList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Bank"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-date-input
                                    input-format="dd/mm/yyyy"
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.expiry_date"
                                    label="Expiry Date"
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-date-input
                                    input-format="dd/mm/yyyy"
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.last_shipment_date"
                                    label="Last Shipment Date"
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-date-input
                                    input-format="dd/mm/yyyy"
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.lc_open_date"
                                    label="LC Open Date"
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.lc_amount"
                                    label="LC Amount"
                                    type="number"
                                    prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.margin_percent"
                                    label="Margin Percent (%)"
                                    type="number"
                                    suffix="%"
                                ></v-text-field>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.margin_amount"
                                    label="Margin Amount"
                                    type="number"
                                    prefix="৳"
                                ></v-text-field>
                              </v-col>


                              <v-col cols="12" md="6" >

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.currency_id"
                                    :items="getCurrencyList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Currency"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.incoterm_id"
                                    :items="getLcIncotermList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Incoterm"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.payment_term_id"
                                    :items="getLcPaymentTermList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Payment Term"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.loading_port_id"
                                    :items="getLcPortList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Loading Port"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.discharge_port_id"
                                    :items="getLcPortList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Discharge Port"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.shipping_method_id"
                                    :items="getLcShippingMethodList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="Shipping Method"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.bank_charge"
                                    label="Bank Charge"
                                    type="number"
                                    prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.swift_charge"
                                    label="Swift Charge"
                                    type="number"
                                    prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.insurance"
                                    label="Insurance"
                                    type="number"
                                    prefix="৳"
                                ></v-text-field>

                                <v-text-field
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.presentation_period"
                                    label="Presentation Period (Days)"
                                    type="number"
                                ></v-text-field>

                                <v-autocomplete
                                    variant="outlined"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    v-model="updates.value.value.lc_type_id"
                                    :items="getLcTypeList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    label="LC Type"
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                              </v-col>
                            </v-row>

                            <v-alert
                                v-else
                                type="info"
                                density="compact"
                                class="mt-2"
                            >
                              Please select an LC first
                            </v-alert>

                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">

                      <v-expansion-panels v-model="panel3" multiple >
                        <v-expansion-panel>

                          <v-expansion-panel-title class="panel-header">
                            PI Items Amendment
                          </v-expansion-panel-title>

                          <v-expansion-panel-text>
                            <div v-if=" selectedLcData && selectedLcData.pis && selectedLcData.pis.length > 0 ">
                              <div
                                  v-for="pi in selectedLcData.pis"
                                  :key="`pi-${pi.id}-${pi.details?.length || 0}`"
                                  class="mb-4"
                              >

                                <v-card variant="outlined" class="mb-3" >
                                  <v-card-title
                                      class="text-subtitle-1 bg-grey-lighten-4"
                                  >
                                    PI: {{ pi.pi_no || pi.code }} - {{ formattedDate(pi.pi_date) }}
                                  </v-card-title>

                                  <v-card-text>
                                    <v-data-table
                                        :key="`table-${pi.id}-${pi.details?.length || 0}`"
                                        :headers="piItemHeaders"
                                        :items="getPiItemsForAmendment(pi)"
                                        density="compact"
                                        class="elevation-0"
                                        :items-per-page="-1"
                                        hide-default-footer
                                    >

                                      <template v-slot:item.product="{ item }">
                                        <v-autocomplete
                                            v-if="item.isNew"
                                            v-model="item.product_id"
                                            :items="getMappedProductsForPi(pi)"
                                            :item-title="
                                            item =>
                                              item && item.product
                                                ? `${item.product.name} - ${item.product.code}`
                                                : ''
                                          "
                                            item-value="product_id"
                                            density="compact"
                                            variant="outlined"
                                            hide-details
                                            @update:model-value="
                                            val => {
                                              item.product_id = val;
                                              selectProductForItem(pi.id,item,val);
                                            }
                                          "
                                        
                                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                        <span v-else>
                                          {{ item.product?.name || 'N/A' }}
                                        </span>

                                      </template>

                                      <template v-slot:item.product.unit.name="{ item }">
                                        {{ item.product?.unit?.name || item.uom || 'N/A' }}
                                      </template>

                                      <template v-slot:item.qty="{ item }">
                                        <v-text-field
                                            v-model.number="item.qty"
                                            type="number"
                                            density="compact"
                                            variant="outlined"
                                            hide-details
                                            @update:model-value="
                                          () => updatePiItem(pi.id, item)
                                          "
                                            @blur="
                                            () => updatePiItem(pi.id, item)
                                          "
                                        ></v-text-field>
                                      </template>

                                      <template v-slot:item.rate="{ item }">
                                        <v-text-field
                                            v-model.number="item.rate"
                                            type="number"
                                            density="compact"
                                            variant="outlined"
                                            hide-details
                                            @update:model-value="
                                          () => updatePiItem(pi.id, item)
                                          "
                                            @blur="
                                            () => updatePiItem(pi.id, item)
                                          "
                                        ></v-text-field>

                                      </template>


                                      <!-- AMOUNT -->

                                      <template v-slot:item.amount="{ item }">
                                        {{
                                          formatNumber(item.amount ||((parseFloat(item.qty) || 0) * (parseFloat(item.rate) || 0)))
                                        }}
                                      </template>

                                      <template v-slot:item.actions="{ item }">
                                        <v-btn
                                            icon="mdi-delete"
                                            size="small"
                                            variant="text"
                                            color="error"
                                            @click="
                                            removePiItem(pi.id, item)
                                          "
                                        ></v-btn>
                                      </template>
                                    </v-data-table>

                                    <v-btn
                                        class="mt-2"
                                        size="small"
                                        color="primary"
                                        prepend-icon="mdi-plus"
                                        @click="addNewPiItem(pi.id)"
                                    >
                                      Add Item
                                    </v-btn>
                                  </v-card-text>

                                </v-card>

                              </div>
                            </div>

                            <v-alert
                                v-else
                                type="info"
                                density="compact"
                                class="mt-2"
                            >
                              No PI data available for the selected LC
                            </v-alert>

                          </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                          <v-expansion-panel-title class="panel-header">
                            Add New PIs to LC
                          </v-expansion-panel-title>

                          <v-expansion-panel-text class="pt-4">
                            <v-autocomplete
                                v-if="selectedLcData"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="new_pis.value.value"
                                :items="getAvailablePiList"
                                :item-title="
                                  item =>
                                    `${item.pi_no} - ${item.code} (${formattedDate(
                                      item.pi_date
                                    )}) - ${formatNumber(item.total_amount)}`
                                "
                                item-value="id"
                                label="Select New Proforma Invoices (PI)"
                                multiple
                                chips
                                clearable
                                @update:model-value="loadNewPiDetails"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                              <template #label>
                                New Proforma Invoices (PI)
                              </template>
                            </v-autocomplete>

                            <v-alert
                                v-else
                                type="info"
                                density="compact"
                                class="mt-2"
                            >
                              Please select an LC first
                            </v-alert>

                            <div v-if=" newPisDetails && newPisDetails.length > 0" class="mt-4" >
                              <div
                                  v-for="pi in newPisDetails"
                                  :key="`new-pi-${pi.id}`"
                                  class="mb-4"
                              >

                                <v-card
                                    variant="outlined"
                                    class="mb-3"
                                >

                                  <v-card-title
                                      class="text-subtitle-1 bg-blue-lighten-4"
                                  >
                                    New PI:{{ pi.pi_no || pi.code }}-{{ formattedDate(pi.pi_date) }}

                                    <v-chip
                                        color="success"
                                        size="small"
                                        class="ml-2"
                                    >
                                      New
                                    </v-chip>

                                  </v-card-title>

                                  <v-card-text>
                                    <v-row class="mb-2">

                                      <v-col
                                          cols="12"
                                          md="6"
                                      >
                                        <strong>Supplier:</strong>
                                        {{ pi.supplier?.name || pi.supplier?.supplier_name || 'N/A' }}
                                      </v-col>

                                      <v-col cols="12" md="6" >
                                        <strong>Total Amount:</strong>
                                        {{ formatNumber(pi.total_amount) }}
                                      </v-col>
                                    </v-row>

                                    <v-data-table
                                        :headers="piItemHeaders"
                                        :items="pi.details || []"
                                        density="compact"
                                        class="elevation-0"
                                        :items-per-page="-1"
                                        hide-default-footer
                                    >

                                      <template v-slot:item.product="{ item }">
                                        {{ item.product?.name || 'N/A' }}
                                      </template>

                                      <template v-slot:item.product.unit.name="{ item }">
                                        {{ item.product?.unit?.name || item.uom || 'N/A' }}
                                      </template>

                                      <template v-slot:item.qty="{ item }">
                                        {{ formatNumber(item.qty) }}
                                      </template>

                                      <template v-slot:item.rate="{ item }">
                                        {{ formatNumber(item.rate) }}
                                      </template>

                                      <template v-slot:item.amount="{ item }">
                                        {{
                                          formatNumber( item.amount || ((parseFloat(item.qty) || 0) * (parseFloat(item.rate) || 0) ) )
                                        }}
                                      </template>
                                    </v-data-table>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </div>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>

                  <v-row>

                    <v-col cols="12" class="text-center" >

                      <v-btn
                          class="bg-red mr-2"
                          variant="flat"
                          @click="goBack"
                      >
                        Cancel
                      </v-btn>

                      <v-btn
                          class="bg-brand"
                          variant="flat"
                          type="submit"
                          :loading="loading"
                      >
                        {{ isEditMode ? 'Update Amendment' : 'Save Amendment' }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>


<script>
import { ref, computed, onMounted, nextTick } from 'vue';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';

export default {
  name: 'LcImportLcAmendment',
  methods: {
    formattedDate,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const panel = ref([0]);
    const panel1 = ref([0]);
    const panel2 = ref([0]);
    const panel3 = ref([0]);

    const loading = ref(false);
    const selectedLcData = ref(null);
    const isEditMode = ref(false);
    const newPisDetails = ref([]);
    const loadingNewPis = ref(false);
    const originalPiSnapshot = ref({});

    const amendmentTypeOptions = [
      'Expiry Change',
      'Qty Change',
      'Port Change',
      'PI Change',
      'Amount Change',
      'Date Change',
      'Other',
    ];

    const piItemHeaders = [
      { title: 'Product', key: 'product', sortable: false, },
      { title: 'UOM', key: 'product.unit.name', sortable: false, },
      { title: 'Quantity', key: 'qty', sortable: false, align: 'center', },
      { title: 'Rate', key: 'rate', sortable: false, align: 'center', },
      { title: 'Amount', key: 'amount', sortable: false, align: 'right', },
      { title: 'Actions', key: 'actions', sortable: false, width: '10%', },
    ];

    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        lc_id: yup.number().positive().integer().required().label('LC'),
        amendment_no: yup.string().required().label('Amendment No'),
        amendment_date: yup.date().required().label('Amendment Date'),
      }),
    });


    const lc_id = useField('lc_id');

    const amendment_no = useField('amendment_no', undefined, { initialValue: '' });
    const amendment_date = useField('amendment_date');
    const amendment_types = useField('amendment_types', undefined, { initialValue: [] });
    const amendment_charge = useField('amendment_charge', undefined, { initialValue: 0 });
    const remarks = useField('remarks', undefined, { initialValue: '' });
    const documents = useField('documents', undefined, { initialValue: [] });
    const updates = useField('updates', undefined, { initialValue: {} });
    const pi_item_updates = useField('pi_item_updates', undefined, { initialValue: [] });
    const new_pis = useField('new_pis', undefined, { initialValue: [] });


    const getLcImportLcMasterList = computed(() => {
      return store.getters.getLcImportLcMasterList || [];
    });
    const getCurrencyList = computed(() => {
      return store.getters.getCurrencyList || [];
    });
    const getLcPortList = computed(() => {
      return store.getters.getLcPortList || [];
    });
    const getLcTypeList = computed(() => {
      return store.getters.getLcTypeList || [];
    });
    const getSupplierList = computed(() => {
      return store.getters.getSupplierList || [];
    });
    const getLcBankList = computed(() => {
      return store.getters.getLcBankList || [];
    });
    const getLcIncotermList = computed(() => {
      return store.getters.getLcIncotermList || [];
    });
    const getLcPaymentTermList = computed(() => {
      return store.getters.getLcPaymentTermList || [];
    });
    const getLcShippingMethodList = computed(() => {
      return store.getters.getLcShippingMethodList || [];
    });
    const getLcImportPiList = computed(() => {
      const pis = store.getters.getLcImportPiList || [];

      return pis.filter(item => item.branch_id == branchId.value && item.status == 1);
    });

    const getAvailablePiList = computed(() => {
      if (!selectedLcData.value || !selectedLcData.value.pis) {
        return getLcImportPiList.value;
      }
      const attachedPiIds = selectedLcData.value.pis.map(pi => pi.id);

      return getLcImportPiList.value.filter(
          pi => !attachedPiIds.includes(pi.id)
      );
    });
    const getProductList = computed(() => {
      return store.getters.getProductList || [];
    });
    const branchId = computed(() => {
      return (store.getters.getAuthUser?.branch_id || null);
    });
    const getProductMapList = computed(() => {
      const products = store.getters.getProductMapList || [];
      return products.filter(item => item.branch_id == branchId.value && item.status == 1);
    });


    const getMappedProductsForPi = () => {
      return getProductMapList.value;
    };

    const cloneData = data => {
      if (data === null || data === undefined) {
        return data;
      }
      return JSON.parse(JSON.stringify(data));
    };

    const numberValue = value => {
      const number = parseFloat(value);
      return Number.isFinite(number) ? number : 0;
    };

    const hasPiItemChanged = (originalItem, currentItem) => {
      if (!originalItem || !currentItem) {
        return false;
      }

      const originalQty = numberValue(originalItem.qty);
      const currentQty = numberValue(currentItem.qty);
      const originalRate = numberValue(originalItem.rate);
      const currentRate = numberValue(currentItem.rate);
      const originalProductId = originalItem.product_id ?? null;
      const currentProductId = currentItem.product_id ?? null;

      return (
          Math.abs(originalQty - currentQty) > 0.0001 ||
          Math.abs(originalRate - currentRate) > 0.0001 ||
          originalProductId !== currentProductId
      );
    };

    const getPiUpdate = piId => {
      if (!Array.isArray(pi_item_updates.value.value)) {
        pi_item_updates.value.value = [];
      }

      let piUpdate = pi_item_updates.value.value.find(item => Number(item.pi_id) === Number(piId));

      if (!piUpdate) {
        piUpdate = {
          pi_id: piId,
          added: [],
          removed: [],
          updated: [],
        };

        pi_item_updates.value.value.push(piUpdate);
      }

      return piUpdate;
    };

    const loadLcData = async lcId => {
      if (!lcId) {
        selectedLcData.value = null;
        originalPiSnapshot.value = {};
        pi_item_updates.value.value = [];
        return;
      }

      try {
        loading.value = true;

        // if (!store.getters.getProductMapList || store.getters.getProductMapList.length === 0) {
          await store.dispatch('getProductMapList', {});
        // }

        const lcData = await store.dispatch('getLcImportLcMasterById', lcId);

        selectedLcData.value = lcData;

        if (lcData) {
          updates.value.value = {
            expiry_date: lcData.expiry_date ? new Date(lcData.expiry_date) : null,
            last_shipment_date: lcData.last_shipment_date ? new Date(lcData.last_shipment_date) : null,
            lc_open_date: lcData.lc_open_date ? new Date(lcData.lc_open_date) : null,
            lc_amount: lcData.lc_amount || 0,
            margin_percent: lcData.margin_percent || 0,
            margin_amount: lcData.margin_amount || 0,
            currency_id: lcData.currency_id || null,
            supplier_id: lcData.supplier_id || null,
            bank_id: lcData.bank_id || null,
            incoterm_id: lcData.incoterm_id || null,
            payment_term_id: lcData.payment_term_id || null,
            loading_port_id: lcData.loading_port_id || null,
            discharge_port_id: lcData.discharge_port_id || null,
            shipping_method_id: lcData.shipping_method_id || null,
            bank_charge: lcData.bank_charge || 0,
            swift_charge: lcData.swift_charge || 0,
            insurance: lcData.insurance || 0,
            presentation_period: lcData.presentation_period || 21,
            lc_type_id: lcData.lc_type_id || null,
          };

          originalPiSnapshot.value = {};

          if (Array.isArray(lcData.pis)) {
            lcData.pis.forEach(pi => {
              originalPiSnapshot.value[pi.id] = {
                id: pi.id,
                pi_no: pi.pi_no,
                code: pi.code,
                pi_date: pi.pi_date,
                details: cloneData(pi.details || []),
              };
            });

            pi_item_updates.value.value = lcData.pis.map(pi => ({
              pi_id: pi.id,
              added: [],
              removed: [],
              updated: [],
            }));
          } else {
            pi_item_updates.value.value = [];
          }
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to load LC data');
      } finally {
        loading.value = false;
      }
    };

    const getPiItemsForAmendment = pi => {
      if (!pi || !Array.isArray(pi.details)) {
        return [];
      }

      return pi.details.map(item => {
        const qty = numberValue(item.qty);
        const rate = numberValue(item.rate);
        item.qty = qty;
        item.rate = rate;
        item.amount = qty * rate;

        return item;
      });
    };

    const updatePiItem = (piId, item) => {
      if (!item) {
        return;
      }

      const piUpdate = getPiUpdate(piId);
      const qty = numberValue(item.qty);
      const rate = numberValue(item.rate);
      const amount = qty * rate;

      item.qty = qty;
      item.rate = rate;
      item.amount = amount;

      if (item.isNew) {
        let addedItem = piUpdate.added.find(
            added =>
                added === item ||
                (!added.id && !item.id && Number(added.product_id) === Number(item.product_id))
        );

        if (!addedItem) {
          if (item.product_id) {
            addedItem = {
              id: null,
              product_id: item.product_id,
              qty,
              rate,
              amount,
              uom: item.uom || item.product?.unit?.name || 'PCS',
              hs_code: item.hs_code || null,
            };

            /*
             * IMPORTANT:
             * Keep reference to the actual UI item.
             * This means future qty/rate changes update the same added record.
             */
            piUpdate.added.push(addedItem);
          }
        } else {
          addedItem.qty = qty;
          addedItem.rate = rate;
          addedItem.amount = amount;
          addedItem.product_id = item.product_id;
          addedItem.uom = item.uom || item.product?.unit?.name || 'PCS';
          addedItem.hs_code = item.hs_code || null;
        }

        return;
      }

      /* =====================================================
         EXISTING ITEM
      ===================================================== */
      if (!item.id) {
        return;
      }

      const originalPi = originalPiSnapshot.value[piId];

      if (!originalPi) {
        console.warn('Original PI snapshot not found:', piId);
        return;
      }

      const originalItem = originalPi.details?.find(
          detail => Number(detail.id) === Number(item.id)
      );

      if (!originalItem) {
        console.warn('Original PI item not found:', item.id);
        return;
      }

      const changed = hasPiItemChanged(originalItem, item);

      /* =====================================================
         ITEM IS CHANGED
      ===================================================== */
      if (changed) {
        const existingIndex = piUpdate.updated.findIndex(
            updated => Number(updated.id) === Number(item.id)
        );

        const updatedItem = {
          id: item.id,
          product_id: item.product_id,
          qty,
          rate,
          amount,
          uom: item.uom || item.product?.unit?.name || originalItem.uom || 'PCS',
          hs_code: item.hs_code || originalItem.hs_code || null,
        };

        if (existingIndex !== -1) {
          // Update existing update record.
          piUpdate.updated[existingIndex] = updatedItem;
        } else {
          // First time this item changed.
          piUpdate.updated.push(updatedItem);
        }

        /*
         * If item was previously marked removed and then somehow
         * changed again, remove it from removed.
         */
        piUpdate.removed = piUpdate.removed.filter(
            removed => Number(removed.id) !== Number(item.id)
        );
      }
      /* =====================================================
         ITEM RETURNED TO ORIGINAL VALUE
      ===================================================== */
      else {
        /*
         * Very important.
         * If user changes qty 1000 -> 2000 and then back to 1000,
         * there should NOT be an updated record.
         */
        piUpdate.updated = piUpdate.updated.filter(
            updated => Number(updated.id) !== Number(item.id)
        );
      }
    };


    /* =========================================================
       SELECT PRODUCT FOR NEW ITEM
    ========================================================= */
    const selectProductForItem = (piId, item, productId) => {
      if (!item || !productId) {
        return;
      }

      const productMap = getProductMapList.value.find(
          pm => Number(pm.product_id) === Number(productId)
      );

      if (!productMap || !productMap.product) {
        return;
      }

      const product = productMap.product;

      item.product = product;
      item.product_id = productId;
      item.uom = product.unit?.name || 'PCS';

      // Automatically populate purchase rate.
      if (product.purchase_rate !== null && product.purchase_rate !== undefined) {
        item.rate = numberValue(product.purchase_rate);
      }

      item.amount = numberValue(item.qty) * numberValue(item.rate);

      // Register it inside added.
      updatePiItem(piId, item);
    };


    /* =========================================================
       REMOVE PI ITEM
    ========================================================= */
    const removePiItem = async (piId, item) => {
      if (!item) {
        return;
      }

      const pi = selectedLcData.value?.pis?.find(
          currentPi => Number(currentPi.id) === Number(piId)
      );

      if (!pi) {
        console.warn('PI not found:', piId);
        return;
      }

      const piUpdate = getPiUpdate(piId);

      /* =====================================================
         NEW ITEM
      ===================================================== */
      if (item.isNew) {
        /*
         * A newly added item is NOT a removed item.
         * Simply remove it from added.
         */
        piUpdate.added = piUpdate.added.filter(
            added =>
                added !== item &&
                !(!added.id && !item.id && Number(added.product_id) === Number(item.product_id))
        );

        // Remove from UI.
        if (Array.isArray(pi.details)) {
          const index = pi.details.findIndex(detail => detail === item);

          if (index !== -1) {
            pi.details.splice(index, 1);
          }
        }

        await nextTick();
        return;
      }

      /* =====================================================
         EXISTING ITEM
      ===================================================== */
      if (!item.id) {
        return;
      }

      // Before removing the item, get its original values from the snapshot.
      const originalPi = originalPiSnapshot.value[piId];

      const originalItem = originalPi?.details?.find(
          detail => Number(detail.id) === Number(item.id)
      );

      // If already removed, don't duplicate.
      const alreadyRemoved = piUpdate.removed.some(
          removed => Number(removed.id) === Number(item.id)
      );

      if (!alreadyRemoved) {
        piUpdate.removed.push({
          id: item.id,
          product_id: item.product_id,
          // Send the ORIGINAL values. This is better for backend audit/history.
          qty: numberValue(originalItem?.qty ?? item.qty),
          rate: numberValue(originalItem?.rate ?? item.rate),
          amount: numberValue(
              originalItem?.amount ??
              (numberValue(originalItem?.qty ?? item.qty) * numberValue(originalItem?.rate ?? item.rate))
          ),
        });
      }

      // A removed item cannot simultaneously remain in updated.
      piUpdate.updated = piUpdate.updated.filter(
          updated => Number(updated.id) !== Number(item.id)
      );

      // Remove item from current UI.
      if (Array.isArray(pi.details)) {
        const index = pi.details.findIndex(
            detail => Number(detail.id) === Number(item.id)
        );

        if (index !== -1) {
          pi.details.splice(index, 1);
        }
      }

      await nextTick();
    };


    /* =========================================================
       ADD NEW PI ITEM
    ========================================================= */
    const addNewPiItem = piId => {
      const pi = selectedLcData.value?.pis?.find(
          currentPi => Number(currentPi.id) === Number(piId)
      );

      if (!pi) {
        return;
      }

      if (!Array.isArray(pi.details)) {
        pi.details = [];
      }

      const newItem = {
        id: null,
        product_id: null,
        product: null,
        qty: 0,
        rate: 0,
        amount: 0,
        uom: 'PCS',
        hs_code: null,
        isNew: true,
      };

      // Add to UI.
      pi.details.push(newItem);

      /*
       * IMPORTANT: Do not immediately add to the payload.
       * It doesn't have a product yet. It will be registered
       * in `added` when the user selects a product.
       */
    };


    /* =========================================================
       LOAD NEW PI DETAILS
    ========================================================= */
    const loadNewPiDetails = async piIds => {
      if (!piIds || piIds.length === 0) {
        newPisDetails.value = [];
        return;
      }

      loadingNewPis.value = true;

      try {
        const detailsPromises = piIds.map(async piId => {
          try {
            return await store.dispatch('getLcImportPiById', piId);
          } catch (error) {
            console.error(`Failed to load PI ${piId}:`, error);
            return null;
          }
        });

        const details = await Promise.all(detailsPromises);

        newPisDetails.value = details.filter(pi => pi !== null);
      } catch (error) {
        console.error('Error loading new PI details:', error);
        toast.error('Failed to load PI details');
      } finally {
        loadingNewPis.value = false;
      }
    };


    /* =========================================================
       PREPARE PI UPDATE PAYLOAD
    ========================================================= */
    const preparePiItemUpdates = () => {
      if (!Array.isArray(pi_item_updates.value.value)) {
        return [];
      }

      return pi_item_updates.value.value
          .map(piUpdate => ({
            pi_id: piUpdate.pi_id,

            added: Array.isArray(piUpdate.added)
                ? piUpdate.added
                    .filter(item => item.product_id)
                    .map(item => ({
                      product_id: item.product_id,
                      qty: numberValue(item.qty),
                      rate: numberValue(item.rate),
                      amount: numberValue(item.amount),
                      uom: item.uom || 'PCS',
                      hs_code: item.hs_code || null,
                    }))
                : [],

            removed: Array.isArray(piUpdate.removed)
                ? piUpdate.removed.map(item => ({
                  id: item.id,
                  product_id: item.product_id,
                  qty: numberValue(item.qty),
                  rate: numberValue(item.rate),
                  amount: numberValue(item.amount),
                }))
                : [],

            updated: Array.isArray(piUpdate.updated)
                ? piUpdate.updated.map(item => ({
                  id: item.id,
                  product_id: item.product_id,
                  qty: numberValue(item.qty),
                  rate: numberValue(item.rate),
                  amount: numberValue(item.amount),
                  uom: item.uom || 'PCS',
                  hs_code: item.hs_code || null,
                }))
                : [],
          }))
          // Only send PIs which actually contain a change.
          .filter(pi => pi.added.length > 0 || pi.removed.length > 0 || pi.updated.length > 0);
    };


    /* =========================================================
       SUBMIT
    ========================================================= */
    const submit = handleSubmit(async values => {
      try {
        loading.value = true;

        /* ===================================================
           AMENDMENT TYPES
        =================================================== */
        let amendmentTypesArray = [];

        if (amendment_types.value.value) {
          if (Array.isArray(amendment_types.value.value)) {
            amendmentTypesArray = amendment_types.value.value;
          } else if (typeof amendment_types.value.value === 'string') {
            try {
              amendmentTypesArray = JSON.parse(amendment_types.value.value);
            } catch {
              amendmentTypesArray = [amendment_types.value.value];
            }
          }
        }

        /* ===================================================
           FORM DATA
        =================================================== */
        const formData = {
          lc_id: lc_id.value.value,
          amendment_no: amendment_no.value.value || '',
          amendment_date: formattedDate(amendment_date.value.value),
          amendment_types: amendmentTypesArray,
          updates: {},
          pi_item_updates: [],
          new_pis: Array.isArray(new_pis.value.value) ? new_pis.value.value : [],
          amendment_charge: numberValue(amendment_charge.value.value),
          remarks: remarks.value.value || '',
        };

        /* ===================================================
           LC MASTER CHANGES
        =================================================== */
        const currentLc = selectedLcData.value;
        const updatesObj = {};

        if (currentLc && updates.value.value) {
          Object.keys(updates.value.value).forEach(key => {
            const newValue = updates.value.value[key];
            const oldValue = currentLc[key];

            let normalizedNewValue = newValue;
            let normalizedOldValue = oldValue;

            // Date normalization
            if (newValue instanceof Date) {
              normalizedNewValue = formattedDate(newValue);
            }

            if (oldValue) {
              // Normalize old date values to compare properly.
              if (key.includes('date') && typeof oldValue === 'string') {
                normalizedOldValue = formattedDate(new Date(oldValue));
              }
            }

            /*
             * Number normalization.
             * This prevents "500" vs 500 from being considered different.
             */
            if (
                [
                  'lc_amount',
                  'margin_percent',
                  'margin_amount',
                  'bank_charge',
                  'swift_charge',
                  'insurance',
                  'presentation_period',
                  'supplier_id',
                  'bank_id',
                  'currency_id',
                  'incoterm_id',
                  'payment_term_id',
                  'loading_port_id',
                  'discharge_port_id',
                  'shipping_method_id',
                  'lc_type_id',
                ].includes(key)
            ) {
              if (normalizedNewValue !== null && normalizedNewValue !== undefined) {
                normalizedNewValue = numberValue(normalizedNewValue);
              }

              if (normalizedOldValue !== null && normalizedOldValue !== undefined) {
                normalizedOldValue = numberValue(normalizedOldValue);
              }
            }

            // Only send changed LC fields.
            if (normalizedNewValue !== normalizedOldValue) {
              if (normalizedNewValue !== null && normalizedNewValue !== undefined) {
                updatesObj[key] = normalizedNewValue;
              }
            }
          });
        }

        formData.updates = Object.keys(updatesObj).length > 0 ? updatesObj : [];

        /* ===================================================
           PI ITEM CHANGES
        =================================================== */
        formData.pi_item_updates = preparePiItemUpdates();

        /* ===================================================
           DEBUG
        =================================================== */
        console.log('================================');
        console.log('full form data');
        console.log(JSON.stringify(formData.pi_item_updates, null, 2));
        console.log('================================');

        /* ===================================================
           DOCUMENTS
        =================================================== */
        if (documents.value.value && documents.value.value.length > 0) {
          formData.documents = documents.value.value;
        }

        /* ===================================================
           SAVE
        =================================================== */
        await store.dispatch('saveUpdateLcImportLcAmendment', formData);

        toast.success('LC Amendment saved successfully');

        router.push({ path: '/lc/import-lc-amendment-record' });
      } catch (error) {
        console.error('Save amendment error:', error);
        toast.error(error.response?.data?.message || 'Failed to save LC Amendment');
      } finally {
        loading.value = false;
      }
    });


    /* =========================================================
       GO BACK
    ========================================================= */
    const goBack = () => {
      router.push({ path: '/lc/import-lc-amendment-record' });
    };


    /* =========================================================
       FORMAT NUMBER
    ========================================================= */
    const formatNumber = num => {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numberValue(num));
    };


    /* =========================================================
       ON MOUNTED
    ========================================================= */
    onMounted(async () => {
      try {
        loading.value = true;


        await store.dispatch('getLcImportLcMasterList', { type: 'lc_for_amendment' });


        /* CURRENCY */
        try {
          // if (!store.getters.getCurrencyList || store.getters.getCurrencyList.length === 0) {
            await store.dispatch('getCurrencyList');
          // }
        } catch (e) {
          console.warn('Failed to load Currency List:', e);
        }

        /* PORT */
        try {
          // if (!store.getters.getLcPortList || store.getters.getLcPortList.length === 0) {
            await store.dispatch('getLcPortList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Port List:', e);
        }

        /* LC TYPE */
        try {
          // if (!store.getters.getLcTypeList || store.getters.getLcTypeList.length === 0) {
            await store.dispatch('getLcTypeList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Type List:', e);
        }

        /* SUPPLIER */
        try {
          // if (!store.getters.getSupplierList || store.getters.getSupplierList.length === 0) {
            await store.dispatch('getSupplierList', {});
          // }
        } catch (e) {
          console.warn('Failed to load Supplier List:', e);
        }

        /* BANK */
        try {
          // if (!store.getters.getLcBankList || store.getters.getLcBankList.length === 0) {
            await store.dispatch('getLcBankList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Bank List:', e);
        }

        /* INCOTERM */
        try {
          // if (!store.getters.getLcIncotermList || store.getters.getLcIncotermList.length === 0) {
            await store.dispatch('getLcIncotermList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Incoterm List:', e);
        }

        /* PAYMENT TERM */
        try {
          // if (!store.getters.getLcPaymentTermList || store.getters.getLcPaymentTermList.length === 0) {
            await store.dispatch('getLcPaymentTermList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Payment Term List:', e);
        }

        /* SHIPPING METHOD */
        try {
          // if (!store.getters.getLcShippingMethodList || store.getters.getLcShippingMethodList.length === 0) {
            await store.dispatch('getLcShippingMethodList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Shipping Method List:', e);
        }

        /* PI LIST */
        try {
          // if (!store.getters.getLcImportPiList || store.getters.getLcImportPiList.length === 0) {
            await store.dispatch('getLcImportPiList');
          // }
        } catch (e) {
          console.warn('Failed to load LC Import PI List:', e);
        }

        /* PRODUCT LIST */
        try {
          // if (!store.getters.getProductList || store.getters.getProductList.length === 0) {
            await store.dispatch('getProductList', {});
          // }
        } catch (e) {
          console.warn('Failed to load Product List:', e);
        }

        /* PRODUCT MAP */
        try {
          // if (!store.getters.getProductMapList || store.getters.getProductMapList.length === 0) {
            await store.dispatch('getProductMapList', {});
          // }
        } catch (e) {
          console.warn('Failed to load Product Map List:', e);
        }

        /* EDIT MODE */
        if (route.params.id) {
          isEditMode.value = true;
          // Edit functionality can be added here.
        }
      } catch (error) {
        console.error('Error in onMounted:', error);
        toast.error('Failed to initialize page. Please refresh.');
      } finally {
        loading.value = false;
      }
    });

    return {
      panel,
      panel1,
      panel2,
      panel3,
      loading,
      selectedLcData,
      isEditMode,
      newPisDetails,
      loadingNewPis,
      lc_id,
      amendment_no,
      amendment_date,
      amendment_types,
      amendment_charge,
      remarks,
      documents,
      updates,
      pi_item_updates,
      new_pis,
      getLcImportLcMasterList,
      getLcImportPiList,
      getAvailablePiList,
      getCurrencyList,
      getLcPortList,
      getLcTypeList,
      getSupplierList,
      getLcBankList,
      getLcIncotermList,
      getLcPaymentTermList,
      getLcShippingMethodList,
      getProductList,
      getProductMapList,
      getMappedProductsForPi,
      amendmentTypeOptions,
      piItemHeaders,
      loadLcData,
      getPiItemsForAmendment,
      updatePiItem,
      removePiItem,
      addNewPiItem,
      selectProductForItem,
      loadNewPiDetails,
      submit,
      goBack,
      formatNumber,
    };
  },
};
</script>


<style scoped>

.panel-header {
  font-weight: 600;
}

</style>
